export const ADD_LINK_ATT_CAT_DETAILS = "ADD_LINK_ATT_CAT_DETAILS";
export const FETCH_LINK_ATT_CAT_LIST = "FETCH_LINK_ATT_CAT_LIST";
export const EDIT_LINK_ATT_CAT_DETAILS = "EDIT_LINK_ATT_CAT_DETAILS";
export const UPDATE_LINK_ATT_CAT_DETAILS = "UPDATE_LINK_ATT_CAT_DETAILS";
export const DELETE_LINK_ATT_CAT_DETAILS = "DELETE_LINK_ATT_CAT_DETAILS";
export const FETCH_LINK_ATT_CAT_DROPDOWN_LIST =
  "FETCH_LINK_ATT_CAT_DROPDOWN_LIST";
export const RESET_LINK_CATE_ATT = "RESET_LINK_CATE_ATT";
